import axios from "axios";

export default function ApiPbxClient() {
  const apiBaseUrl = localStorage.getItem("tenantPbxUrl");
  const apiKey = localStorage.getItem("tenantKey");
  const opId = localStorage.getItem("opId");

  if (!apiBaseUrl || !apiKey) return null;
  else
    return axios.create({
      baseURL: apiBaseUrl,
      headers: {
        uiod: apiKey,
        opId: opId,
      },
    });
}
